import { useToastNotificationContext } from "~contexts/ToastNotification";
import { ToastErrorIcon, ToastSuccessIcon } from "~components/Icons";
import { getStyles } from "./styles";

const Toast = () => {
  const { isShowing, message, type } = useToastNotificationContext();
  const { styles } = getStyles(type, isShowing);

  return (
    <div style={styles.container}>
      <div style={styles.icon}>
        {type === "error" ? <ToastErrorIcon /> : <ToastSuccessIcon />}
      </div>
      <div>
        <h1 style={styles.title}>{message.title}</h1>
        <p style={styles.text}>{message.text}</p>
      </div>
    </div>
  );
};

export default Toast;
